import $ from "jquery";

import { requestTypeset } from "./mathjax_typeset";

$(() => {
  requestTypeset();
});
